import type {
  BulkAccessRequest,
  BulkAccessResult,
} from '~/features/access-control/types/AccessControl';

import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

import type { ServerBulkAccessResult } from './bulkAccessMapper';

import {
  mapBulkAccessRequest,
  mapBulkAccessResultResponse,
} from './bulkAccessMapper';

export const bulkUpdateAccess = async (
  request: BulkAccessRequest,
  options: ServiceRequestConfig = {},
): Promise<BulkAccessResult> => {
  const serverResponse = await pilot.post<ServerBulkAccessResult>(
    '/access/bulk/',
    mapBulkAccessRequest(request),
    options,
  );

  return mapBulkAccessResultResponse(serverResponse);
};
